import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const RemoveMeticsFilters = () => {
  const location = useLocation()

  useEffect(() => {
    const isMetricsPage =
      location.pathname.includes('/metrics') || location.pathname === '/merchant-dashboard' || location.pathname === '/'

    const hasMetricsFilters = localStorage.getItem('metricsFiltersParams')

    if (!isMetricsPage && hasMetricsFilters) {
      localStorage.removeItem('metricsFiltersParams')
    }
  }, [location.pathname])

  return null
}
export default RemoveMeticsFilters
